import moment from 'moment'
import { getFormattedAddress } from '../../../../utils/GoogleMapsUtils'
import { isEmpty } from '../../../../utils/stringUtils'
import {
    ActivationObject,
    LegalObjectType,
    PhysicalObjectType,
} from '../../../providers/ActivationObjectProvider/types'
import { PersonAuthorisationTypes } from '../../Step1/constants'
import {
    LegalObjectTypeDesc,
    PhysicalObjectTypeDesc,
} from '../../Step2/constants'
import { Step4DataProps } from '../types'

const useStep4Data = (activationObject?: ActivationObject): Step4DataProps => {
    const handoverDescText = () => {
        if (activationObject?.handoverKeysDateTime) {
            return `Předání klíčů: ${moment(
                activationObject.handoverKeysDateTime,
                'YYYY-MM-DD kk:mm',
            ).format('DD.MM.YYYY kk:mm')} - ${moment(
                activationObject.handoverKeysDateTime,
                'YYYY-MM-DD kk:mm',
            )
                .add(2, 'hours')
                .format('kk:mm')}`
        } else if (activationObject?.backHandoverKeysDateTime) {
            return `Vrácení klíčů: ${moment(
                activationObject.backHandoverKeysDateTime,
                'YYYY-MM-DD kk:mm',
            ).format('DD.MM.YYYY kk:mm')} - ${moment(
                activationObject.backHandoverKeysDateTime,
                'YYYY-MM-DD kk:mm',
            )
                .add(2, 'hours')
                .format('kk:mm')}`
        }
    }

    const houseNum = isEmpty(activationObject?.objectGuidanceNumber)
        ? activationObject?.objectCodeNumber
        : activationObject?.objectCodeNumber +
          '/' +
          activationObject?.objectGuidanceNumber

    const objecTypeText =
        activationObject &&
        activationObject.personType &&
        activationObject.objectType
            ? activationObject.personType === 'Legal'
                ? LegalObjectTypeDesc[
                      activationObject.objectType as LegalObjectType
                  ]
                : PhysicalObjectTypeDesc[
                      activationObject.objectType as PhysicalObjectType
                  ]
            : ''

    const invoiceAddressFormatted = activationObject
        ? activationObject.invoiceAddressName +
          ', ' +
          getFormattedAddress(
              activationObject.invoiceAddressZIP,
              activationObject.invoiceAddressCity,
              activationObject.invoiceAddressStreet,
              activationObject.invoiceAddressCodeNumber,
              activationObject.invoiceAddressGuidanceNumber,
              false,
          )
        : ''

    const booleanToText = (val?: boolean | null) => (val ? 'Ano' : 'Ne')
    return {
        ...activationObject,
        personTypeText:
            activationObject?.personType === 'Physical'
                ? 'Fyzická osoba'
                : 'Právnická osoba',
        permissionTypeText: activationObject?.personAuthorisationType
            ? PersonAuthorisationTypes[activationObject.personAuthorisationType]
            : '',
        useSettingsAnotherContractText: booleanToText(
            activationObject?.useSettingsAnotherContract,
        ),
        unifyInvoicingText: booleanToText(activationObject?.unifyInvoicing),
        addressFormatted:
            activationObject?.objectStreet +
            ' ' +
            (houseNum !== undefined && houseNum !== null && houseNum !== ''
                ? houseNum
                : ''),
        objecTypeText,
        objectSizeText:
            activationObject?.objectSize === 'LessOrEqual500'
                ? 'Do 500 m²'
                : 'Nad 500 m²',
        handoverKeysText: handoverDescText() || 'Bez předání nebo vrácení',
        setControlChipsText: booleanToText(activationObject?.setControlChips),
        customerPresenceText: booleanToText(activationObject?.customerPresence),
        showChipping:
            activationObject?.setControlChips === true &&
            activationObject?.handoverKeys === 'NotHandoverKeys',
        chippingDateText: activationObject?.handoverKeysDateTime
            ? `${moment(activationObject.handoverKeysDateTime).format(
                  'DD.MM.yyyy HH:mm',
              )} - ${moment(activationObject.handoverKeysDateTime)
                  .add(2, 'hours')
                  .format('HH:mm')}`
            : '',
        instructionsSuitText: booleanToText(
            activationObject?.complyWithGuidelines,
        ),
        contactPersonsText:
            activationObject && activationObject.personContacts
                ? activationObject.personContacts.map((person) => {
                      return `${person.fullName}, ${person.phone}, ${
                          person.email || ''
                      } (${
                          person.role === 'Admin' ? 'Administrátor' : 'Uživatel'
                      })`
                  })
                : [],
        invoiceAddressFormatted,
    }
}

export default useStep4Data
